import { get, writable } from 'svelte/store';
import { ActivityService } from '../../services/activity.service';
export const loading = writable(false);
export const filter = writable({ criteria: {}, params: null, sorting: "" });
export const records = writable([]);
export const pagination = writable(null);
export async function initList(dossierId) {
    let criteria = { query: '', dossierId: dossierId };
    filter.set({ criteria: criteria, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ActivityService.getActivities(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
